module.exports = __webpack_public_path__ + "media/images/bluepinrts_white_top_bg-e968f770161e9c76bfd9e3a5302c0fa6.png";